import { InvestorDetailsEntityTypeEnum } from '../../types';
import AllocationsTable from './table/table';

interface BeginAllocationTabProps {
  entityType: InvestorDetailsEntityTypeEnum;
}

export const BeginAllocationTab = ({ entityType }: BeginAllocationTabProps) => {
  return <AllocationsTable entityType={entityType} />;
};
